import {
  IProjectSpaceTypeCategoryOrSubcategory,
  ProjectSlimForList,
  ProjectStatus,
  ProjectType,
  ProjectsSortingParams,
} from 'spw-redux/modules/projects/types';
import {
  CUSTOM_SUBCATEGORY,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  PRIVATE_OFFICES_SUBCATEGORY,
  SUPPORT_SPACES_CATEGORY,
  WORKSTATIONS_SUBCATEGORY,
} from 'spw-constants';
import { SortBy } from 'spw-components/collab/types';
import { debounce, omit } from 'lodash';
import { getProjects } from 'spw-api/projects';
import { IProjectSpaceType } from 'spw-redux/modules/space_types/types';
import { ProjectsFilters } from './types';

export const getFilterId = (filter: { id?: string | number }) =>
  filter?.id !== 'all' && filter?.id ? filter.id : null;

export const isIWCategoryOrSubcategory = (
  projectSpaceTypeCategory: IProjectSpaceTypeCategoryOrSubcategory
) => {
  return [
    INDIVIDUAL_WORKSPACES_CATEGORY,
    PRIVATE_OFFICES_SUBCATEGORY,
    WORKSTATIONS_SUBCATEGORY,
    CUSTOM_SUBCATEGORY,
  ].includes(projectSpaceTypeCategory?.defaultSpaceTypeCategory?.category);
};

export const isCustomSubcategory = (
  projectSpaceTypeCategory: IProjectSpaceTypeCategoryOrSubcategory
) =>
  CUSTOM_SUBCATEGORY ===
  projectSpaceTypeCategory?.defaultSpaceTypeCategory?.category;

export const isWorkstationOrPrivateOfficeSubcategory = (
  category: IProjectSpaceTypeCategoryOrSubcategory
) =>
  [WORKSTATIONS_SUBCATEGORY, PRIVATE_OFFICES_SUBCATEGORY].includes(
    category?.defaultSpaceTypeCategory?.category
  );

export const isSupportSpace = (spaceType: IProjectSpaceType) =>
  spaceType?.category?.defaultSpaceTypeCategory?.category ===
  SUPPORT_SPACES_CATEGORY;

export const mapFiltersToApiParams = (
  filters: ProjectsFilters,
  sortBy: SortBy<keyof ProjectsSortingParams>,
  page = 1,
  perPage = 20
) => {
  return {
    type: getFilterId(filters.projectType) as ProjectType,
    clientId: getFilterId(filters.client) as number,
    clientIds: filters.clients ? filters.clients.map(getFilterId) : undefined,
    industryId: getFilterId(filters.industry) as number,
    industryIds: filters.industries
      ? filters.industries.map(getFilterId)
      : undefined,
    locations: filters.locations?.map((location) => omit(location, 'id')),
    isHeadquarters: filters.isHeadquarters,
    status: getFilterId(filters.projectStatus) as ProjectStatus,
    search: filters.search,
    minProjectStartYear: filters.minProjectStartYear,
    maxProjectStartYear: filters.maxProjectStartYear,
    minClientMoveInYear: filters.minClientMoveInYear,
    maxClientMoveInYear: filters.maxClientMoveInYear,
    minProjectUSF: filters.minProjectUSF ? filters.minProjectUSF : undefined,
    maxProjectUSF: filters.maxProjectUSF ? filters.maxProjectUSF : undefined,
    perPage,
    page,
    sort: sortBy ? { [sortBy.column]: sortBy.direction } : undefined,
  };
};
export const getProjectsSuggestions = debounce(
  (
    filters: ProjectsFilters,
    onResultsFound: (projects: ProjectSlimForList[]) => void
  ) => {
    getProjects(mapFiltersToApiParams(filters, null, 1, 100))
      .then((r) =>
        onResultsFound(r.data.projects.projects as ProjectSlimForList[])
      )
      .catch(() => onResultsFound([]));
  },
  500
);
